import { render, staticRenderFns } from "./IS-datapoints-widget.vue?vue&type=template&id=05ea60be"
import script from "./IS-datapoints-widget.vue?vue&type=script&lang=js"
export * from "./IS-datapoints-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports